export default __webpack_public_path__ + "static/media/logo-card-480w.93832423.webp";